var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleDimensions(_vm.widget)),attrs:{"data-x":_vm.widget.x,"data-y":_vm.widget.y,"data-w":_vm.widget.w,"data-h":_vm.widget.h}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08fa22ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/vue-interactjs.vue
// module id = 74
// module chunks = 0